import { create } from 'zustand';

import { getCreationWithData } from '../services/api/creations';
import { getFooter } from '../services/api/emails';
import {
  fetchTemplates,
  getAllEmails,
  getSelectionEmails,
} from '../services/emailTemplatesService';

import { Event, SGTemplates } from '../types';
import { isProduction } from '../utils';

export const SETTINGS_PREVIEW_EVENT_ID = isProduction()
  ? 'eb6e8339-32f7-4787-924d-c74040644410'
  : '42569265-cbdd-4f23-bd7c-9fccc14ac542';

export const SETTINGS_PREVIEW_FACE_ID = isProduction()
  ? 'd2da39b4-1f3f-40a1-bf05-497e98b0802b'
  : '62b810c1-5c08-46dd-9173-f5afe157d73b';

interface ProjectSettingsStore {
  previewPerson: any;
  allEmailTemplates: SGTemplates;
  customEmailTemplates: Record<string, SGTemplates>;
  footer: string;

  setPreviewPerson: () => Promise<void>;
  setAllEmailTemplates: (event: Event) => Promise<void>;
  setCustomEmailTemplates: (emailType: string) => Promise<void>;
  setFooter: () => Promise<void>;
}

export const useProjectSettingsStore = create<ProjectSettingsStore>(
  (set, get) => ({
    previewPerson: {},
    allEmailTemplates: {},
    customEmailTemplates: {},
    footer: '',

    setPreviewPerson: async () => {
      const previewPerson = await getCreationWithData(
        SETTINGS_PREVIEW_EVENT_ID,
        SETTINGS_PREVIEW_FACE_ID,
      );

      set({ previewPerson });
    },

    setAllEmailTemplates: async (event) => {
      const emails = getAllEmails(event);
      const allEmailTemplates = await fetchTemplates(emails);

      set({ allEmailTemplates });
    },

    setCustomEmailTemplates: async (emailType) => {
      const emails = getSelectionEmails(emailType);
      const emailTemplates = await fetchTemplates(emails);

      set({
        customEmailTemplates: {
          ...get().customEmailTemplates,
          [emailType]: emailTemplates,
        },
      });
    },

    setFooter: async () => {
      const footer = await getFooter();
      set({ footer });
    },
  }),
);
